export default __webpack_public_path__ + "static/about-d20005f8e832fda6f1410c88ae7c03a4.jpg";